import { Box, Link, Radio, RadioGroup, Typography } from '@mui/material';
import { ExternalLink, THIRTY_DAY_TRIAL_DURATION } from '@localstack/constants';
import { ReactElement } from 'react';

import { PlanChoice } from '../types';

import { SectionDivider } from './SectionDivider';
import { OptionList, OptionRow, SELECTED_OPTION_CLASS } from './styled';

type PlanOption = {
  value: PlanChoice;
  title: string;
  summary: ReactElement;
};

const PLAN_OPTIONS: PlanOption[] = [
  {
    value: PlanChoice.FREE,
    title: 'Hobby',
    summary: <>Free forever for non-commercial projects.</>,
  },
  {
    value: PlanChoice.TRIAL,
    title: 'Trial',
    summary: (
      <>
        Try{' '}
        <Link
          href={ExternalLink.MARKETING_PRICING}
          target="_blank"
          rel="noopener noreferrer"
          underline="always"
          color="inherit"
        >
          Ultimate
        </Link>{' '}
        features free for {THIRTY_DAY_TRIAL_DURATION} days.
      </>
    ),
  },
];

type Props = {
  planChoice: PlanChoice;
  onPlanChoiceChange: (choice: PlanChoice) => void;
};

export const PlanChoiceSection = ({ planChoice, onPlanChoiceChange }: Props): ReactElement => (
  <>
    <Box mt={2}>
      <SectionDivider label="Choose plan" />
    </Box>
    <Box mt={0.5}>
      <RadioGroup value={planChoice} onChange={(_, value) => onPlanChoiceChange(value as PlanChoice)}>
        <OptionList>
          {PLAN_OPTIONS.map((plan) => (
            <OptionRow
              key={plan.value}
              value={plan.value}
              control={<Radio size="small" />}
              labelPlacement="start"
              className={planChoice === plan.value ? SELECTED_OPTION_CLASS : undefined}
              label={
                <Box display="flex" alignItems="baseline" gap={0.75} py={0.75}>
                  <Typography fontWeight={600} fontSize={13}>
                    {plan.title}
                  </Typography>
                  <Typography color="text.secondary" fontSize={12} lineHeight={1.2}>
                    &middot; {plan.summary}
                  </Typography>
                </Box>
              }
            />
          ))}
        </OptionList>
      </RadioGroup>
    </Box>
  </>
);
